export default "__VITE_ASSET__Dld2GQDB__"